import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCw, Share2 } from 'lucide-react';

interface ControlsProps {
  onRefresh: () => void;
  onShare: () => void;
  isLoading?: boolean;
}

export const Controls: React.FC<ControlsProps> = ({ onRefresh, onShare, isLoading = false }) => {
  return (
    <footer className="pb-8 md:pb-16">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="flex justify-center space-x-4"
        >
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={onRefresh}
            disabled={isLoading}
            className="bg-white bg-opacity-5 backdrop-blur-lg border border-white border-opacity-10 text-white p-3 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            title="刷新内容 (按 R 键)"
          >
            <RefreshCw 
              className={`text-lg ${isLoading ? 'animate-spin' : ''}`} 
              size={20}
            />
          </motion.button>
          
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={onShare}
            disabled={isLoading}
            className="bg-white bg-opacity-5 backdrop-blur-lg border border-white border-opacity-10 text-white p-3 rounded-full hover:bg-white hover:bg-opacity-20 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
            title="分享内容 (按 S 键)"
          >
            <Share2 className="text-lg" size={20} />
          </motion.button>
        </motion.div>
      </div>
    </footer>
  );
};